import React from 'react';
import { Box, Button, Flex, Text } from '@mantine/core';
import { ILinkedEmail } from '@/entities/admin-app/email';
import { useUpdateInfo } from '@/hooks/users/useUpdateUser';
import { ProfileSectionEnum, ProfileUpdateTypeEnum } from '@/types/enums/users';
import { useTranslation } from 'react-i18next';
import { UseFormReturnType } from '@mantine/form';
import { showNotification } from '@mantine/notifications';
import { IUsePopUpUI } from '@components/UI/PopUp';
import { useMediaQuery } from '@mantine/hooks';

interface IDeleteEmailModalProps extends IUsePopUpUI {
  form: UseFormReturnType<any>;
  selectedEmail: ILinkedEmail | null;
  sectionFormKey: string;
  editUser?: boolean;
  currentId?: number;
  listEmails: ILinkedEmail[] | null;
  onSuccess?: () => void;
}
export const DeleteEmailModal = ({
  form,
  selectedEmail,
  sectionFormKey,
  editUser,
  currentId,
  listEmails,
  setIsOpen,
  onSuccess
}: IDeleteEmailModalProps) => {
  const { t } = useTranslation();
  const { saveUpdate } = useUpdateInfo();
  const modalClose = () => setIsOpen(false);

  const handleDeleteEmail = async () => {
    if (editUser && currentId) {
      const filteredEmailsList = listEmails?.filter((email) => email.Id !== selectedEmail?.Id);
      await saveUpdate({
        Type: ProfileUpdateTypeEnum.Email,
        Data: { [ProfileSectionEnum.LinkedEmail]: filteredEmailsList || [], Id: currentId }
      });

      if (onSuccess) {
        onSuccess();
      }

      modalClose();
    } else {
      form.setFieldValue(`${sectionFormKey}`, []);
      showNotification({
        title: t('profile.deletedSuccessMessage'),
        message: '',
        autoClose: true,
        color: 'green',
        style: { zIndex: 1003 }
      });
      modalClose();
    }
  };
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Box p={12} w={isMobile ? '100%' : 300}>
      <Text mb="1rem" fz="md">
        {t('profile.areYouSureToDelete')} {selectedEmail?.Email} ?
      </Text>
      <Flex justify="space-between" gap={12}>
        <Button fullWidth color="red" variant="filled" onClick={handleDeleteEmail}>
          {t('profile.untie')}
        </Button>
        <Button fullWidth color="gray" variant="outline" onClick={modalClose}>
          {t('profile.cancel')}
        </Button>
      </Flex>
    </Box>
  );
};
